import PropTypes from "prop-types"

const StatCardCompact = ({ title, stat, icon, bgColor = "bg-indigo-500" }) => (
  <div className="relative overflow-hidden rounded-lg shadow-lg bg-content1">
    <div className={`absolute rounded-start-md ${bgColor} flex items-center p-3 h-full`}>
      {icon}
    </div>

    <div className="my-1 ml-2">
      <div>
        <p className="ml-16 text-sm text-indigo-500 truncate">{title}</p>
      </div>

      <div className="flex items-baseline ml-16">
        <p className="text-2xl font-semibold text-foreground">{stat}</p>
      </div>
    </div>
  </div>
)

StatCardCompact.propTypes = {
  bgColor: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  stat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default StatCardCompact
